import moment from 'moment-timezone';

/**
 * A `datetimezone` parameter value, `"YYYY-MM-DDTHH:mm:ss Europe/Amsterdam"`, split into its halves. `timezone` is null when
 * the value carries none: an empty value, or a bare datetime.
 */
export const parseDateTimeZoneValue = (raw: unknown): { datetime: string; timezone: string | null } => {
  const str = String(raw ?? '').trim();
  const spaceIndex = str.lastIndexOf(' ');
  if (spaceIndex > 0) {
    return { datetime: str.slice(0, spaceIndex).trim(), timezone: str.slice(spaceIndex + 1).trim() };
  }
  return { datetime: str, timezone: null };
};

/** Where the zone in effect comes from while none is picked. */
export type DateTimeZoneFallbackSource = 'parameter' | 'local';

/**
 * The zone a `datetimezone` parameter's datetime is written in while no zone is picked: the one its value already carries,
 * else the browser's.
 */
export const dateTimeZoneFallback = (raw: unknown): { zone: string; source: DateTimeZoneFallbackSource } => {
  const { timezone } = parseDateTimeZoneValue(raw);
  return timezone === null ? { zone: moment.tz.guess(), source: 'local' } : { zone: timezone, source: 'parameter' };
};
